export default __webpack_public_path__ + "static/media/social_media3.b0fb9ce8.jpg";